export default {
	data() {
		return {
			timer: []
		};
	},
	beforeDestroy() {
		this.clear_timer();
	},
	methods: {
		clear_timer() {
			if (!this.timer.length) return false;
			this.timer.forEach((id) => {
				clearTimeout(id);
				clearInterval(id);
			});
			this.timer.splice(0);
		}
	}
};
